import React from 'react';
import { Link } from 'react-router-dom';

function LandingPage() {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      {/* 헤더 */}
      <header style={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        padding: '16px 24px', borderBottom: '1px solid rgba(255,255,255,0.06)',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <span style={{ fontSize: '1.2rem', fontWeight: 700, color: '#F59E0B' }}>keunson</span>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <Link to="/login" className="btn btn-outline" style={{ padding: '8px 16px', fontSize: '0.85rem' }}>
            로그인
          </Link>
          <Link to="/register" className="btn btn-primary" style={{ padding: '8px 16px', fontSize: '0.85rem' }}>
            무료 시작하기
          </Link>
        </div>
      </header>

      {/* 히어로 섹션 */}
      <main style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 24px', textAlign: 'center' }}>
        <div style={{
          fontSize: '0.8rem', color: '#F59E0B', background: 'rgba(245,158,11,0.1)',
          border: '1px solid rgba(245,158,11,0.2)', borderRadius: 20, padding: '4px 14px', marginBottom: 24,
        }}>
          스트리머를 위한 실시간 후원 분석 서비스
        </div>

        <h1 style={{ fontSize: '2.4rem', fontWeight: 700, lineHeight: 1.3, marginBottom: 16, maxWidth: 600 }}>
          당신의 <span style={{ color: '#F59E0B' }}>큰손</span>을<br />
          실시간으로 탐지하세요
        </h1>

        <p style={{ fontSize: '1.05rem', color: '#8B8B9E', lineHeight: 1.7, maxWidth: 500, marginBottom: 40 }}>
          투네이션, 펀네이션, YouTube 수퍼챗을 한곳에서 모아보고,
          고액 후원자가 방송에 들어오면 즉시 알림을 받으세요.
        </p>

        <div style={{ display: 'flex', gap: 12, marginBottom: 60 }}>
          <Link to="/register" className="btn btn-primary" style={{ padding: '12px 32px', fontSize: '1rem' }}>
            무료로 시작하기
          </Link>
          <Link to="/login" className="btn btn-outline" style={{ padding: '12px 32px', fontSize: '1rem' }}>
            로그인
          </Link>
        </div>

        {/* 기능 카드 */}
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: 16, maxWidth: 800, width: '100%',
        }}>
          <div className="card" style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '1.5rem', marginBottom: 8 }}>&#x1F4B0;</div>
            <h3 style={{ fontSize: '1rem', marginBottom: 6 }}>실시간 후원 수집</h3>
            <p style={{ fontSize: '0.85rem', color: '#8B8B9E', lineHeight: 1.6 }}>
              투네이션, 펀네이션, YouTube 수퍼챗을 자동으로 수집하고 통합 관리합니다.
            </p>
          </div>

          <div className="card" style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '1.5rem', marginBottom: 8 }}>&#x1F451;</div>
            <h3 style={{ fontSize: '1rem', marginBottom: 6 }}>큰손 랭킹</h3>
            <p style={{ fontSize: '0.85rem', color: '#8B8B9E', lineHeight: 1.6 }}>
              시청자별 누적 후원 금액을 분석하고, 큰손/잠재큰손/단골을 자동 분류합니다.
            </p>
          </div>

          <div className="card" style={{ textAlign: 'left' }}>
            <div style={{ fontSize: '1.5rem', marginBottom: 8 }}>&#x1F514;</div>
            <h3 style={{ fontSize: '1rem', marginBottom: 6 }}>실시간 알림</h3>
            <p style={{ fontSize: '0.85rem', color: '#8B8B9E', lineHeight: 1.6 }}>
              큰손이 방송에 입장하면 즉시 브라우저 알림으로 알려드립니다.
            </p>
          </div>
        </div>
      </main>

      {/* 푸터 */}
      <footer style={{
        textAlign: 'center', padding: '24px', borderTop: '1px solid rgba(255,255,255,0.06)',
        fontSize: '0.8rem', color: '#6B6B7E',
      }}>
        <div style={{ marginBottom: 8 }}>
          <Link to="/privacy" style={{ color: '#6B6B7E', marginRight: 16 }}>개인정보처리방침</Link>
          <Link to="/terms" style={{ color: '#6B6B7E' }}>서비스 약관</Link>
        </div>
        <p>&copy; 2026 SAGUO. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default LandingPage;
